module.exports = __webpack_public_path__ + "static/media/rebirth_34.288a9ead.jpg";